import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import BrowserMockup from './BrowserMockup';

export type ScreenshotItem = {
  label: string;
  image?: string | null;
};

interface ScreenshotGalleryProps {
  items: ScreenshotItem[];
  url?: string;
  gradient?: string;
}

function ScreenshotGallery({ items, url, gradient = 'from-blue-600/20 to-purple-600/20' }: ScreenshotGalleryProps) {
  const [activeIndex, setActiveIndex] = useState(0);
  const active = items[activeIndex];

  if (!items.length) return null;

  return (
    <div>
      <div className={`bg-gradient-to-br ${gradient} p-4 sm:p-6`}>
        <AnimatePresence mode="wait">
          <motion.div
            key={active.label}
            initial={{ opacity: 0, y: 8, filter: 'blur(6px)' }}
            animate={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
            exit={{ opacity: 0, y: -8, filter: 'blur(6px)' }}
            transition={{ duration: 0.35 }}
          >
            {active.image ? (
              <BrowserMockup src={active.image} alt={active.label} url={url} />
            ) : (
              <BrowserMockup
                src=""
                alt={active.label}
                url={url}
                placeholder={active.label}
              />
            )}
          </motion.div>
        </AnimatePresence>
      </div>

      {items.length > 1 && (
        <div className="flex flex-wrap gap-2 p-4 sm:px-6 border-t border-line bg-surface">
          {items.map((item, index) => (
            <button
              key={item.label}
              type="button"
              onClick={() => setActiveIndex(index)}
              className={`text-xs font-medium px-3 py-1.5 rounded-md border transition-colors ${
                index === activeIndex
                  ? 'bg-accent-muted/60 border-accent/30 text-ink'
                  : 'border-line text-ink-muted hover:text-ink hover:bg-canvas-muted'
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default ScreenshotGallery;
